import { RoutingService } from './../../../home/services/routing.service';
import { Component, OnInit, Inject, PLATFORM_ID   } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {

  showPageNotFound: boolean = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.showPageNotFound = true;
    }
  }

  navigateHome() {
    this.navigationService.navigateMerchantLanding();
  }

}
